import { Component, effect, input, viewChild } from '@angular/core';
import { IonNav, IonicModule } from '@ionic/angular';
import { RecordRootComponent } from './record-root.component';

@Component({
  selector: 'app-record',
  imports: [IonicModule],
  template: `<ion-nav></ion-nav>`,
})
export class RecordPage {
  nav = viewChild(IonNav);
  id = input<number>();

  constructor() {
    effect(() => {
      const idVal = this.id();
      const nav = this.nav();
      if (nav === undefined) {
        return;
      }
      void nav.setRoot(RecordRootComponent, {
        id: idVal,
        ionNav: nav,
      });
    });
  }
}
